import React, { Fragment, useEffect, useRef, useState, Component } from "react"
import {
    Button, Card, CardBody, CardSubtitle, CardTitle, Col, Container, Modal, Row, Label
} from "reactstrap"
import DetailBloc from "./Blocs/DetailBloc"
import { Link } from "react-router-dom"
import { AvForm } from "availity-reactstrap-validation";
import { FileInput, generateFormData, generateFormDataMultiple } from '../../../helpers/ui/FileInput'
import { ConfirmAlert } from "../../../helpers/ui/alert";
import apiResponse from "../../../services/apiResponse";
import { Redirect } from "react-router-dom/cjs/react-router-dom";
import SimpleBar from "simplebar-react"
import Sidebar from "./Sidebar";
import Tree from "./Tree"
import Shimmer from "react-shimmer-effect";

class IndexView extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        folders: null,
        dataForm: null,
        activeUpload: "konversi_nip",
        confirm: null,
        loading: null,
        success: null,
        failed: null,
        confirmGenerate: null,
        loadingGenerate: null,
        successGenerate: null,
        failedGenerate: null,
        redirect: false,
        activeFolder: null
      };
  
      this.queryParams = new URLSearchParams(window.location.search);
      this.detailBloc = new DetailBloc();
      this.handleFolderList = this.handleFolderList.bind(this);
      this.handleUploadDocument = this.handleUploadDocument.bind(this);
      this.handleGenerateFolder = this.handleGenerateFolder.bind(this);
    }
  
    componentDidMount() {
      this.detailBloc.folderListChannel.subscribe(this.handleFolderList);
      this.detailBloc.uploadDocumentChannel.subscribe(this.handleUploadDocument);
      this.detailBloc.generateFolderChannel.subscribe(this.handleGenerateFolder);
  
      this.detailBloc.fetchFolderList({employee_uuid: this.queryParams.get('uuid')});
    }
  
    componentWillUnmount() {
      this.detailBloc.folderListChannel?.unsubscribe();
      this.detailBloc.uploadDocumentChannel?.unsubscribe();
      this.detailBloc.generateFolderChannel?.unsubscribe();
    }
  
    handleFolderList(result) {
      console.log("folder");
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({ folders: response });
          }
          break;
        case apiResponse.ERROR:
          console.log("error");
          break;
        default:
          break;
      }
    }
  
    handleUploadDocument(result) {
      console.log("upload");
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState({ loading: false, success: true });
          } else {
            this.setState({ loading: false, failed: true });
          }
          break;
        case apiResponse.ERROR:
          this.setState({ loading: false, failed: true });
          break;
        default:
          break;
      }
    }
  
    handleGenerateFolder(result) {
      console.log("generate");
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loadingGenerate: false,
            successGenerate: true,
          });
          this.detailBloc.fetchFolderList({
            employee_uuid: this.queryParams.get('uuid'), 
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loadingGenerate: false,
            failedGenerate: true,
          });
          break;
        default:
          break;
      }
    }

    onFolderClicked = (data) => {
        console.log(data)
        this.setState({
            activeFolder: data,
            uploadedDocuments: null
        })
    }

    documentCategories = () => {
        return (
          <Card className="email-leftbar" style={{ width: "100%", height: "80vh", overflowY: "auto" }}>
            {this.state.folders != null && this.state.folders.length == 0 ? (
                <Button
                    type="button"
                    color="info"
                    className="btn-block waves-effect waves-light"
                    onClick={() => {
                        this.setState({
                            confirmGenerate: true
                        })
                    }}
                    block
                >
                    Generate Folder
                </Button>
            ) : <CardTitle>Folder</CardTitle>}
            
            {this.state.folders != null ? (
              <Tree treeData={this.state.folders} folderClicked={this.onFolderClicked} active={this.state.activeFolder?.document_uuid}/>
            ) : 
              <>
                <Shimmer><div style={{width: "100%", height: 20, marginBottom: "20px"}}></div></Shimmer>
                <Shimmer><div style={{width: "100%", height: 20, marginBottom: "20px"}}></div></Shimmer>
                <Shimmer><div style={{width: "100%", height: 20, marginBottom: "20px"}}></div></Shimmer>
                <Shimmer><div style={{width: "100%", height: 20, marginBottom: "20px"}}></div></Shimmer>
                <Shimmer><div style={{width: "100%", height: 20, marginBottom: "20px"}}></div></Shimmer>
              </>
            }
          </Card>
          
        )
    }

    showUploadView = () => {
        return <>
            {
              this.state.activeFolder != null && (
                <>
                  <CardTitle>Upload document pada folder {this.state.activeFolder.document_name}</CardTitle>
                  <hr />
                  <div className="mb-3">
                      <FileInput
                          id="konversi_nip"
                          name="konversi_nip"
                          validate={{ required: { value: false } }}
                          isMultiple= {true}
                          accept=".pdf,.jpg,.png,.jpeg"
                          selectedFiles={this.state.uploadedDocuments}
                          onChange={(files) => {
                              this.setState({
                                  uploadedDocuments: files
                              })
                          }}
                          maxFiles={100} 
                      />
                  </div>
                </>
              )
            }
        </>   
    }
    
    confirmResponse = (response) => {
        switch (response) {
          case "cancel":
            this.setState({confirm: false});
            break;
          case "confirm":
            this.setState({loading: true, confirm: false})
            this.submitData()
            break;
          case "success":
            this.setState({success: false, redirect: true});
            break;
          case "failed":
            this.setState({failed: false})
            break;
          default:
        }
    };

    confirmResponseGenerate = (response) => {
        switch (response) {
          case "cancel":
            this.setState({confirmGenerate: false})
            break;
          case "confirm":
            this.setState({loadingGenerate: true, confirmGenerate: false})
            this.submitGenerate();
            break;
          case "success":
            this.setState({successGenerate: false})
            break;
          case "failed":
            this.setState({failedGenerate: false})
            break;
          default:
        }
    };

    submitGenerate = async () => {
        this.detailBloc.fetchGenerateFolder({
          employee_uuid: this.queryParams.get('uuid'), 
          employee_nip: this.queryParams.get('nip'),
          employee_name: this.queryParams.get('name')
        })
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, "uploaded_documents");
        this.detailBloc.fetchUploadDocument(formData)
    }

    handlerOnSubmit = (e, values) => {
        const uuid = this.queryParams.get('uuid')
        const nip = this.queryParams.get('nip')
        const formData = {
            "employee_uuid": uuid,
            "employee_nip": nip,
            "uploaded_document_uuid": this.state.activeFolder.document_uuid,
            "uploaded_document_path": this.state.activeFolder.document_path,
            "uploaded_documents": this.state.uploadedDocuments,
        }
        
        this.setState({
            dataForm: formData,
            confirm: true
        })
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <AvForm
                        className="needs-validation"
                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                    >
                        <Row>
                            <Col md="4">
                                {this.documentCategories()}
                            </Col>
                            <Col md="8">
                                {this.state.folders != null && this.state.folders.length > 0 && (
                                    <Row>
                                        <Card>
                                            <CardBody>
                                                {this.showUploadView()}
                                            </CardBody>
                                        </Card>
                                    </Row>
                                )}
                                <Row>
                                    <Card>
                                        <CardBody>
                                            <Row>
                                                <Col>
                                                    <Link to="/dms.html">
                                                        <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                    </Link>
                                                    {' '}
                                                    {this.state.uploadedDocuments != null && (
                                                      <Button color="success" type="submit">
                                                          <i className="uil-arrow-up-right"></i> Simpan
                                                      </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Row>
                            </Col>
                        </Row>
                    </AvForm>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
    
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan mengenerate default folder?"
                    loadingTitle="Mengenerate folder..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Folder berhasil digenerate"
                    failedTitle="Gagal!"
                    failedInfo="Folder gagal digenerate"
                    showConfirm={this.state.confirmGenerate}
                    showLoading={this.state.loadingGenerate}
                    showSuccess={this.state.successGenerate}
                    showFailed={this.state.failedGenerate}
                    response={this.confirmResponseGenerate}
                />
                { this.state.redirect ?
                    <Redirect to='/dms.html'/>
                : null }
            </Fragment>
        );
    }
}

export default IndexView;